var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#40B3DB",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.7655814,10.2102326 L10.9339535,17.1311628 C10.6660465,17.3990698 10.2195349,17.3990698 9.95162791,17.1311628 L6.20093023,13.335814 C5.93302326,13.067907 5.93302326,12.6213953 6.20093023,12.3534884 L7.18325581,11.3711628 C7.45116279,11.1032558 7.89767442,11.1032558 8.1655814,11.3711628 L10.1302326,13.3804651 C10.3088372,13.5590698 10.6213953,13.5590698 10.8,13.3804651 L15.8009302,8.20093023 C16.0688372,7.93302326 16.5153488,7.93302326 16.7832558,8.20093023 L17.7655814,9.18325581 C18.0781395,9.45116279 18.0781395,9.89767442 17.7655814,10.2102326 L17.7655814,10.2102326 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.5649b443.svg";
export { ForwardRef as ReactComponent };